// @flow

import React, { PureComponent } from 'react';
import AAUIPagination from 'react-aaui/lib/Pagination';

type Prop = {
  total: number,
  pageNumber: number,
  pageSize: number,
  handleClick?: Function
}

export default class Pagination extends PureComponent<Prop> {
  handleClick = (currentPage: number) => (e: Object) => {
    e.preventDefault();
    const { handleClick } = this.props;
    if (handleClick) {
      handleClick(currentPage);
    }
  }

  renderPaginationLinkElement = (props: Object) => {
    const currentPage = parseInt(props.href.split('=')[1], 10);
    return <a onClick={this.handleClick(currentPage)}>{props.children}</a>;
  }

  render() {
    const { total, pageNumber, pageSize } = this.props;
    return (
      <AAUIPagination
        theme="noborder"
        total={Math.ceil(total / pageSize)}
        current={pageNumber}
        around={1}
        linkElement={this.renderPaginationLinkElement} />
    );
  }
}
